/** Screen A — landing (`/l/:slug`). Owned by the shell agent; the reference implementation for feature routes. */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const LandingPage = lazyRoute(() => import('./LandingPage'), 'lottery');

export const landingRoutes: RouteObject[] = [{ index: true, element: <LandingPage /> }];
